/**
 * Shared constants for WebSocket hub/services/events.
 */
export const HUB_NAMESPACE = 'c1-ws'

/**
 * Topic for leader → followers raw notify change payloads.
 * Payload type: ArrayBuffer (binary ChangedRef)
 */
export const TOPIC_NOTIFY_CHANGED_RAW = 'notify:changed-raw'

/**
 * Topic for leader → all tabs connection status updates.
 * Payload type: { status: 'connected' | 'reconnecting' | 'degraded' }
 */
export const TOPIC_LEADER_CONNECTION_STATUS = 'leader:connection-status'

/**
 * Topic for any tab → leader to force a reconnection attempt.
 * Payload type: {} (empty)
 */
export const TOPIC_FORCE_RECONNECT = 'leader:force-reconnect'
